import UnauthenticatedGate from "./UnauthenticatedGate";

export default UnauthenticatedGate;
